// extracted by mini-css-extract-plugin
export default {"Footer":"luEwuMHzIiSwPf5b76Pu"};